<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
export default{
   metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'AGMAR - Meble kuchenne na wymiar',
      description: 'Jesteśmy firmą, która od dwudziestu lat produkuje meble. Do każdego zamówienia podchodzimy indywidualnie.'
    },
    computed:{
      ...mapState({
        firstVisit: state=>state.firstVisit
      })
    },
    methods:{
      ...mapMutations(['visitState'])
    },
    watch:{
      // eslint-disable-next-line
      $route(to, from){
        if(to.name === 'home'){
          if(this.firstVisit === true){
            this.visitState();
          }
        }
      }
    },
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  height: 100%;
  font-family: 'Roboto', sans-serif;
  color: #2c3e50;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.locked{
  overflow: hidden;
}
</style>
